import { render, staticRenderFns } from "./KanriMenu.vue?vue&type=template&id=75e00ab8&"
import script from "./KanriMenu.vue?vue&type=script&lang=ts&"
export * from "./KanriMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports